import { Flex, Group, Text } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';
import React, { ReactNode } from 'react';

type props = {
  leftSection?: ReactNode;
  label: string;
  checked?: boolean;
};

const CustomSelectOption = ({ leftSection, label, checked }: props) => {
  return (
    <Group flex="1" gap="10px" c={'#0f172a'} wrap={'nowrap'} style={{ minWidth: 0 }}>
      <Flex>{leftSection}</Flex>
      <Text size={'13px'} lh={'1.2'} c={'#0f172a'} style={{ wordBreak: 'break-word' }} flex={'1'}>
        {label}
      </Text>

      {checked && <IconCheck style={{ marginInlineStart: 'auto', color: 'var(--velos-brand-pink)' }} size={16} />}
    </Group>
  );
};

export default CustomSelectOption;
